import { ApplicationConfig, provideBrowserGlobalErrorListeners, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { providePrimeNG } from 'primeng/config';
import { MessageService, ConfirmationService } from 'primeng/api';

registerLocaleData(localeEs);

import { routes } from './app.routes';
import { AUTH_PROVIDERS } from './modules/auth/infrastructure/auth.providers';
import { CLIENT_PROVIDERS } from './modules/clients/infrastructure/client.providers';
import { USER_PROVIDERS } from './modules/users/infrastructure/user.providers';
import { ORDER_PROVIDERS } from './modules/orders/infrastructure/order.providers';
import { QUALITY_CONTROL_PROVIDERS } from './modules/quality-controls/infrastructure/quality-control.providers';
import { PORTFOLIO_PROVIDERS } from './modules/portfolios/infrastructure/portfolio.providers';
import { DASHBOARD_PROVIDERS } from './modules/dashboard/infrastructure/dashboard.providers';
import { DELIVERY_PROVIDERS } from './modules/deliveries/infrastructure/delivery.providers';
import { CONNECTION_PROVIDERS } from './modules/connections/infrastructure/connection.providers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      translation: {
        firstDayOfWeek: 1,
        dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        today: 'Hoy',
        clear: 'Limpiar',
        weekHeader: 'Sm',
      },
    }),
    { provide: LOCALE_ID, useValue: 'es' },
    MessageService,
    ConfirmationService,
    ...AUTH_PROVIDERS,
    ...CLIENT_PROVIDERS,
    ...USER_PROVIDERS,
    ...ORDER_PROVIDERS,
    ...QUALITY_CONTROL_PROVIDERS,
    ...PORTFOLIO_PROVIDERS,
    ...DASHBOARD_PROVIDERS,
    ...DELIVERY_PROVIDERS,
    ...CONNECTION_PROVIDERS,
  ],
};
